import { appStorage } from '../lib/betaStorage'
import React from 'react'

interface Props {
  children: React.ReactNode
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: unknown) {
    console.error('Marnixia crashed:', error)
  }

  reset = () => {
    Array.from({ length: appStorage.length }, (_, index) => appStorage.key(index)!).filter(Boolean)
      .filter((k) => k.startsWith('schub.'))
      .forEach((k) => appStorage.removeItem(k))
    window.location.reload()
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center gap-4 bg-slate-50 px-6 text-center">
        <div className="text-4xl">😵</div>
        <h1 className="text-lg font-bold text-slate-900">Something went wrong</h1>
        <p className="text-sm text-slate-500">
          Marnixia ran into a problem loading your saved data — this can happen after an update. Resetting will clear
          local data on this device and start fresh.
        </p>
        <button onClick={this.reset} className="rounded-2xl bg-brand-600 px-6 py-3 text-sm font-bold text-white shadow-card">
          Reset app data & reload
        </button>
      </div>
    )
  }
}

